/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { makeStyles, useMediaQuery, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import CustomTooltip from "app/common/chart/CustomTooltipComponent";
import { Bar } from "react-chartjs-2";
import _ from "lodash";

const useStyles = makeStyles(() => ({
  chartContainer: {
    flex: 1,
  },
}));

function HistogramChartComponent({
  currentRowPriceByDate,
  rowValueAvg,
  listCycles,
}) {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const chartRef = useRef(null);
  const metadataSlice = useSelector((state) => state.metadata);
  const [tooltipProps, setTooltipProps] = useState({});
  const [chartData, setChartData] = useState({});

  const currentRowPriceByDateChart = _.map(
    currentRowPriceByDate,
    (currentMonthPrice) => {
      return currentMonthPrice - rowValueAvg;
    }
  );

  const setPositionAndData = (payload) => {
    setTooltipProps({
      top: payload.top,
      left: payload.left,
      position: "absolute",
      tooltipModel: payload.tooltipModel,
      showTooltip: true,
      width: "150px",
      smallPadding: true,
    });
  };

  const hide = () => {
    setTooltipProps({
      ...tooltipProps,
      showTooltip: false,
    });
  };

  // useEffect(() => {
  //   const chart = chartRef.current?.chartInstance;
  //   if (_.isEmpty(chart.data.datasets)) return;
  //   chart.update();
  // }, [referenceRow]);

  const chartOptions = {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    // layout: {
    //   padding: {
    //     top: 20,
    //     bottom: 20,
    //   },
    // },
    animation: false,
    tooltips: {
      enabled: false,
      intersect: isSmallScreen,
      mode: "index",
      custom: useCallback((tooltipModel) => {
        if (tooltipModel.opacity === 0) {
          hide();
          return;
        }

        const chart = chartRef.current.chartInstance;
        const { canvas } = chart.ctx;

        if (canvas) {
          // set position of tooltip

          const left =
            tooltipModel.caretX <= chart.width / 2
              ? tooltipModel.caretX + 60
              : tooltipModel.caretX - 280;
          const top = tooltipModel.caretY - 60;

          setPositionAndData({ top, left, tooltipModel });
        }
      }, []),
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            lineWidth: 0,
          },
          ticks: {
            display: false,
            // beginAtZero: true,
            // suggestedMax: 2,
            // suggestedMin: -14,
            maxTicksLimit: 3,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            display: false,
          },
          gridLines: {
            display: false,
            lineWidth: 1,
          },
        },
      ],
    },
  };

  const chartDataUpdate = (barBackgroundColor) => {
    return {
      labels: listCycles,
      datasets: [
        {
          backgroundColor: barBackgroundColor,
          hoverBackgroundColor: "#A67C00",
          barPercentage: 0.3,
          data: currentRowPriceByDateChart,
        },
      ],
    };
  };

  useEffect(() => {
    const barBackgroundColor = _.map(currentRowPriceByDateChart, (price) => {
      if (price > 0) return "gray";
      return "#A9A9A9";
    });

    setChartData(chartDataUpdate(barBackgroundColor));
  }, [currentRowPriceByDate]);

  return (
    <div className={classes.chartContainer}>
      <Bar
        ref={chartRef}
        data={chartData}
        options={chartOptions}
        height="78%"
      />
      {tooltipProps.showTooltip ? (
        <CustomTooltip
          smallPading
          tooltipProps={tooltipProps}
          tooltipData={{ title: "" }}
          items={[
            {
              content: (
                <div>
                  <Typography
                    variant="body2"
                    className={classes.labelPriceTooltip}
                  >
                    Price Out -{" "}
                    {listCycles[tooltipProps.tooltipModel.dataPoints[0].index]}
                  </Typography>
                  <div className={classes.priceTooltipContainer}>
                    <Typography
                      variant="body2"
                      className={classes.spaceBetweenPrice}
                    >
                      {metadataSlice["custom-projection"].price[0].unit}{" "}
                      {
                        currentRowPriceByDate[
                          tooltipProps.tooltipModel.dataPoints[0].index
                        ]
                      }
                    </Typography>
                  </div>
                </div>
              ),
              borderStyle: {
                borderColor: "transparent",
              },
            },
          ]}
        />
      ) : null}
    </div>
  );
}

export default HistogramChartComponent;
